import Vue from 'vue'
import request from '../..//request'
import { Toast } from 'vant';
import loadingComponent from './index.vue'
export default function(Vue,options){
  const LoadingConstructor = Vue.extend(loadingComponent)

  const instance = new LoadingConstructor({
    el: document.createElement('div'),

  })
  let taskId=''
  instance.show = false // 默认隐藏
  Vue.prototype.$orderAuditLoading = {
    show(data,fun) { // 显示方法
      if(!data){
          return;
      }
      instance.show = true
      instance.time=1
      taskId=data
      document.body.appendChild(instance.$el)
      getStatus(fun)
      return instance.close()
      .then(() => {
          fun({close:true})
      })
      .catch(() => {
          return Promise.reject(err);
      });
    },
    hide() { // 隐藏方法
      instance.show = false
    }
  }
  let getStatus=(fun)=>{
      setTimeout(()=>{
          if(!instance.show){
              return;
          }
          instance.time++
          request.get("purchaseOrder/fetchOrderProcess",{taskId:taskId}).then(res=>{
              if(res.status==200){
                  if(res.content.code==1){
                      getStatus(fun)
                  }else if(res.content.code==2){
                    Toast({ message: res.content.msg, type: 'success', duration: 3 * 1000 })
                      fun(res.content)
                      instance.show=false
                  }else if(res.content.code==3){
                    Toast({ message: res.content.msg, type: 'success', duration: 3 * 1000 })
                    fun(res.content)
                    instance.show=false
                  }else{
                    if(!res.content.msg){
                      Toast({ message: '处理成功', type: 'success', duration: 3 * 1000 })
                    }else{
                      Toast({ message: res.content.msg, type: 'error', duration: 3 * 1000 })
                    }
                    fun(res.content)
                    instance.show=false  
                  }
              }else{
                  instance.show=false
              }
          }).catch((err)=>{
              instance.show=false
          })
      },1000)
  }
}
// export default {
//   install() {
//     if (!Vue.$orderAuditLoading) {
//       Vue.$orderAuditLoading = loading
//     }
//     Vue.mixin({
//       created() {
//         this.$orderAuditLoading = Vue.$orderAuditLoading
//         if(this.$orderAuditLoading){
//             this.$orderAuditLoading.hide()
//         }
//       }
//     })
//   }
// }


// WEBPACK FOOTER //
// ./src/components/AuditAsyn/index.js